import { useMemo } from 'react'

import { useAtom } from 'jotai'

import Modal from '@totallymoney/ui/components/Modal'

import { LoanPurpose } from '@appTypes/LoansApi.interface'

import { loanDetailsModalAtom } from '@atoms/loanDetailsModalAtom'

import LoanDetailsModalButton from '@components/LoanDetailsModalButton'
import LoansTableFilterForm, {
    getLoansValidationSchema,
} from '@components/LoansTableFilterForm'

import useAppQueryState from '@hooks/useAppQueryState'

import { LoanFilterLimits } from '@utils/getCategoryLoanFilterLimits'

interface LoanTableFilterProps {
    loanAmount: number
    loanFilterLimits: LoanFilterLimits
    loanTerm: number
}

const UnscoredTableFilter = ({
    loanFilterLimits,
    loanAmount,
    loanTerm,
}: LoanTableFilterProps) => {
    const [isLoanFormModalOpen, setIsLoanFormModalOpen] =
        useAtom(loanDetailsModalAtom)

    const { updateAppQueryState } = useAppQueryState()

    const onCloseModal = () => setIsLoanFormModalOpen(false)

    const validationSchema = useMemo(() => {
        return getLoansValidationSchema({
            minAmount: loanFilterLimits.loanAmount.min,
            maxAmount: loanFilterLimits.loanAmount.max,
            minTerm: loanFilterLimits.loanTerm.min,
            maxTerm: loanFilterLimits.loanTerm.max,
        })
    }, [loanFilterLimits])

    return (
        <>
            <LoanDetailsModalButton
                loanAmount={loanAmount}
                loanTerm={loanTerm}
                setIsLoanFormModalOpen={setIsLoanFormModalOpen}
            />

            <Modal
                isFullScreen
                isOpen={isLoanFormModalOpen}
                onClose={onCloseModal}
                title="Edit loan details"
            >
                <LoansTableFilterForm
                    formValues={{
                        loanAmount,
                        loanTerm,
                        loanPurpose: LoanPurpose.Other,
                    }}
                    loanFilterLimits={loanFilterLimits}
                    onCloseModal={onCloseModal}
                    onFormSubmit={async formValues => {
                        setIsLoanFormModalOpen(false)

                        updateAppQueryState({
                            loanAmount: formValues.loanAmount.toString(),
                            loanTerm: formValues.loanTerm.toString(),
                        })
                    }}
                    showLoanPurpose={false}
                    validationSchema={validationSchema}
                />
            </Modal>
        </>
    )
}

export default UnscoredTableFilter
